import requestFunctions from "../../functions/requestFunctions";

export const state = {
  USERS_ITEM: {},
  USERS_LIST: [],
  USERS_TABLE_DATA: [],
  USERS_ARRAY_DATA: [],
  USERS_TOTAL_ROWS: 0
}

export const getters = {
  GET_USERS_ITEM: (state) => {
    return state.USERS_ITEM;
  },
  GET_USERS_LIST: (state) => {
    return state.USERS_LIST;
  },
  GET_USERS_TABLE_DATA: (state) => {
    return state.USERS_TABLE_DATA;
  },
  GET_USERS_ARRAY_DATA: (state) => {
    return state.USERS_ARRAY_DATA;
  },
  GET_USERS_TOTAL_ROWS: (state) => {
    return state.USERS_TOTAL_ROWS;
  }
}

export const mutations = {
  UPDATE_USERS_ITEM(state, item) {
    state.USERS_ITEM = item;
  },
  UPDATE_USERS_LIST(state, list) {

    state.USERS_LIST = list.data;
    state.USERS_TABLE_DATA = [];
    state.USERS_ARRAY_DATA = [];

    state.USERS_TOTAL_ROWS = list.total;
    list = list.data;
    
    list.forEach(el => {

      let fullname = '';

      if (el.profile_name3 != '' && el.profile_name3 !== null) { fullname = fullname + el.profile_name3 + ' '; }
      if (el.profile_name1 != '' && el.profile_name1 !== null) { fullname = fullname + el.profile_name1 + ' '; }
      if (el.profile_name2 != '' && el.profile_name2 !== null) { fullname = fullname + el.profile_name2 + ' '; }

      let status;

      if(el.status === 'active'){
        status = 'Активный'
      }
      if(el.status === 'wait'){
        status = 'Ожидает активации'
      }
      if(el.status === 'blocked'){
        status = 'Заблокирован'
      }
      if(el.status === 'disabled'){
        status = 'Отключен'
      }

      let role = '';
      if(el.role === 'administrator'){
        role = 'Администратор'
      }
      if(el.role === 'manager'){
        role = 'Менеджер'
      }
      if(el.role === 'consultant'){
        role = 'Консультант'
      }
      if(el.role === 'client'){
        role = 'Клиент'
      }

      let sex = '';
      if(el.sex === 'male'){
        sex = 'Мужчина';
      }
      if(el.sex === 'female'){
        sex = 'Женщина';
      }

      state.USERS_TABLE_DATA.push({
        'id' : el.id,
        'fullname' : fullname,
        'phone'    : el.phone,
        'role'     : role,
        'status'   : status,
        'created_at' : el.created_at,
        'uuid' : el.uuid
      });

      state.USERS_ARRAY_DATA.push({
        id   : el.id,
        name : fullname + ', ' + el.phone,
        role : el.role,
        type : el.type,
        sex  : el.profile_sex
      });

    });
  },
}

export const actions = {

  async FETCH_USERS_REGISTRATION({ commit }, payload) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/users/registration';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'POST');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_USERS_ITEM', response.data);
      return response.data;
    }

  },

  async FETCH_USERS_CONFIRM({ commit }, payload) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/users/confirm';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'POST');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_USERS_ITEM', response.data);
      return response.data;
    }

  },

  async FETCH_USERS_RECOVERY({ commit }, payload) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/users/recovery';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'POST');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

  async FETCH_USERS_LIST({ commit }, payload= {}) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/users';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_USERS_LIST', response.data);
      return response.data;
    }

  },

  async FETCH_USERS_ITEM({ commit }, payload) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/users/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_USERS_ITEM', response.data);
      return response.data;
    }

  },

  async FETCH_USERS_CREATE({ commit }, payload) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/users';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'POST');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

  async FETCH_USERS_UPDATE({ commit }, payload) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/users/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'PUT');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

  async FETCH_USERS_DELETE({ commit }, payload) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/users/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'DELETE');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

}